/* Shared by the editor, public React page and both Node SEO renderers. */
const VARIANTS = {
  hero: [
    { id: 'studio-hero-editorial', name: 'Studio · Editorial Split', description: 'Emergents varma premium-hero med asymmetrisk bild.' },
    { id: 'studio-hero-split-proof', name: 'Studio · Split Proof', description: 'Mörk säljinriktad hero med social proof och siffror.' },
    { id: 'studio-hero-statement', name: 'Signatur · Hero med bild', recommended: true, description: 'Immersiv bildhero och kraftfull typografi.' },
    { id: 'editorial', name: 'Redaktionell', description: 'Stor rubrik, varm grund och ett inramat bildutsnitt.' },
    { id: 'panorama', name: 'Panorama', description: 'Lugn, centrerad introduktion med bred bild.' },
    { id: 'contrast', name: 'Kontrast', description: 'Mörk petrol, tydligt budskap och generös bildyta.' },
  ],
  trust_bar: [
    { id: 'studio-trust-marquee', name: 'Signatur · Logo Marquee', recommended: true, description: 'Kundlogotyper och verifierat betyg i ett kompakt, rörligt band.' },
    { id: 'studio-trust-stat-rail', name: 'Studio · Stat Rail', description: 'Stora verifierade värden på mörk bakgrund.' },
    { id: 'studio-trust-proof-cards', name: 'Studio · Proof Cards', description: 'Fakta och förklaringar i ett redaktionellt uttryck.' },
    { id: 'line', name: 'Signaturrad', description: 'En luftig rad med tydliga fakta och källor.' },
    { id: 'panel', name: 'Inramad', description: 'En sammanhållen yta med varm bakgrund.' },
    { id: 'contrast', name: 'Kontrast', description: 'En mörk, koncentrerad förtroendesektion.' },
  ],
  lead_form: [
    { id: 'studio-form-inline-card', name: 'Studio · Inline Card', description: 'Två snabba fält i ett premiumkort.' },
    { id: 'studio-form-split-contact', name: 'Signatur · Personlig kontakt', recommended: true, description: 'Personlig kontakt, trygghetsbevis och ett ljust formulär.' },
    { id: 'studio-form-stepped', name: 'Studio · Stepped', description: 'Trestegsformulär med progressiv frågeordning.' },
    { id: 'compact', name: 'Kompakt', description: 'Säljande text till vänster och ett tydligt formulärkort.' },
    { id: 'feature', name: 'Premium', description: 'Mörk, varm sektion med ett ljust formulär i fokus.' },
    { id: 'minimal', name: 'Enkel', description: 'Ett avskalat formulär för en kort landningssida.' },
  ],
  testimonials: [
    { id: 'studio-reviews-editorial', name: 'Studio · Editorial', description: 'Typografisk presentation av kundröster.' },
    { id: 'studio-reviews-marquee', name: 'Signatur · Omdömesflöde', recommended: true, description: 'Två svepande rader med kundcitat.' },
    { id: 'studio-reviews-spotlight', name: 'Studio · Spotlight', description: 'Ett stort citat och navigering mellan omdömen.' },
    { id: 'spotlight', name: 'I fokus', description: 'Ett stort kundcitat med kompletterande röster.' },
    { id: 'cards', name: 'Kundkort', description: 'Lättlästa citat i en balanserad kortlayout.' },
    { id: 'journal', name: 'Redaktionell', description: 'En stillsam, numrerad följd av kundröster.' },
  ],
};
const TEMPLATES = {
  hero: { type: 'hero', variant: 'studio-hero-statement', visible: true, eyebrow: '', headline: '', subheadline: '', cta_primary: { text: 'Kontakta oss', link: '/#kontakt' }, cta_secondary: { text: '', link: '' }, hero_image: '', image_alt: '', image_caption: '', title_accent: '', proof_cards: [], rating_claim: {} },
  lead_form: {
    type: 'lead_form', variant: 'studio-form-split-contact', visible: true,
    eyebrow: 'Kostnadsfritt och utan förbindelser',
    title: 'Berätta om ditt projekt.', subtitle: 'Lämna dina uppgifter så återkommer vi med ett konkret nästa steg.',
    button_text: 'Få ett kostnadsfritt förslag',
    success_message: 'Tack! Vi har tagit emot din förfrågan och hör av oss.',
    offer_label: 'Ny hemsida', show_company: false, show_phone: true, show_message: true,
    privacy_link: '/integritetspolicy', contact_people: [], assurances: []
  },
  trust_bar: { type: 'trust_bar', variant: 'studio-trust-marquee', visible: true, eyebrow: '', title: '', items: [], logos: [] },
  testimonials: { type: 'testimonials', variant: 'studio-reviews-marquee', visible: true, eyebrow: 'Kundernas ord', title: '', subtitle: '', items: [] },
};
function createSection(type) { return TEMPLATES[type] ? JSON.parse(JSON.stringify(TEMPLATES[type])) : null; }
function isPremiumSection(section) { return Boolean(section && VARIANTS[section.type]?.some(v => v.id === section.variant)); }
function safeUrl(value, image = false) {
  const url = typeof value === 'string' ? value.trim() : '';
  if (!url || /[\u0000-\u0020\\]/.test(url)) return '';
  if (/^https:\/\/[^/]/i.test(url)) { try { const parsed = new URL(url); return parsed.hostname && !parsed.username && !parsed.password ? url : ''; } catch { return ''; } }
  if (url.startsWith('/') && !url.startsWith('//')) return url;
  if (!image && (/^#[\w-]+$/.test(url) || /^tel:\+?[\d()-]+$/.test(url) || /^mailto:[^<>\s@]+@[^<>\s@]+$/.test(url))) return url;
  return '';
}
function isVerified(item) {
  if (!item || item.verified !== true || !/^https:\/\//i.test(safeUrl(item.source_url))) return false;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(item.verified_at || '')) return false;
  const date = new Date(item.verified_at + 'T00:00:00Z');
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === item.verified_at && item.verified_at <= new Date().toISOString().slice(0, 10);
}
function publishableItems(section) {
  return (Array.isArray(section.items) ? section.items : []).filter(item => isVerified(item) && (section.type === 'testimonials' ? typeof item.quote === 'string' && item.quote.trim() && typeof item.author === 'string' && item.author.trim() : typeof item.label === 'string' && item.label.trim()));
}
function validationErrors(section) {
  const errors = [];
  if (!isPremiumSection(section) || section.visible === false) return errors;
  if (section.type === 'trust_bar' && section.variant === 'studio-trust-marquee') {
    const logos = section.logos || [];
    if (!Array.isArray(logos) || logos.length > 12)
      errors.push('Logo Marquee tillåter högst tolv kundlogotyper.');
    else for (const logo of logos) {
      if (!logo || typeof logo.name !== 'string' || !logo.name.trim() || logo.name.length > 120)
        errors.push('Varje kundlogotyp behöver ett företagsnamn.');
      if (!logo || typeof logo.src !== 'string' || !safeUrl(logo.src, true) || logo.src.length > 2048)
        errors.push('Varje kundlogotyp behöver en giltig bildadress.');
      if (!isVerified(logo))
        errors.push('Varje kundlogotyp behöver en verifierad HTTPS-källa och ett datum.');
      if (logo?.link_url && !safeUrl(logo.link_url))
        errors.push('Logotypens länk måste vara giltig.');
      if (logo?.opaque !== undefined && typeof logo.opaque !== 'boolean')
        errors.push('Bakgrundsinställningen måste vara av/på.');
    }
  }
  if (section.type === 'testimonials') {
    if (section.reviews_cta_url && !safeUrl(section.reviews_cta_url)) errors.push('Omdömeslänken behöver vara giltig.');
    if (String(section.reviews_cta_text || '').length > 130) errors.push('Länktexten är för lång.');
  }
  if (section.type === 'lead_form') {
    const people = section.contact_people || [];
    const assurances = section.assurances || [];
    if (!Array.isArray(people) || people.length > 3) errors.push('Formuläret tillåter högst tre kontaktpersoner.');
    else for (const person of people) {
      if (!person || typeof person.name !== 'string' || !person.name.trim())
        errors.push('Kontaktpersoner behöver namn.');
      for (const [key, limit] of [['name',120],['role',120],['company',160],['phone',60],['email',254],['image',2048]]) {
        if (person && (typeof (person[key] ?? '') !== 'string' || String(person[key] || '').length > limit))
          errors.push('Kontaktpersonens uppgifter är ogiltiga eller för långa.');
      }
      if (person?.email && !/^[^<>\s@]+@[^<>\s@]+\.[^<>\s@]{2,}$/.test(person.email))
        errors.push('Ogiltig e-postadress för kontaktperson.');
      if (person?.phone && !/^[+0-9()\s-]{4,60}$/.test(person.phone))
        errors.push('Ogiltigt telefonnummer för kontaktperson.');
      if (person?.image && !safeUrl(person.image, true)) errors.push('Ogiltig bildadress för kontaktperson.');
    }
    if (!Array.isArray(assurances) || assurances.length > 4 ||
        assurances.some(x => typeof x !== 'string' || x.length > 180))
      errors.push('Högst fyra korta trygghetsargument är tillåtna.');
    if (!String(section.title || '').trim()) errors.push('Formuläret behöver en rubrik.');
    if (!String(section.button_text || '').trim()) errors.push('Formuläret behöver en knapptext.');
    if (String(section.title || '').length > 160) errors.push('Formulärrubriken är för lång.');
    if (String(section.subtitle || '').length > 460) errors.push('Formulärtexten är för lång.');
    if (String(section.button_text || '').length > 100) errors.push('Formulärknappen är för lång.');
    if (String(section.offer_label || '').length > 120) errors.push('Erbjudandets namn är för långt.');
    if (String(section.success_message || '').length > 240) errors.push('Tackmeddelandet är för långt.');
    if (section.privacy_link && !safeUrl(section.privacy_link)) errors.push('Integritetslänken behöver en giltig sökväg eller HTTPS-länk.');
    for (const key of ['show_company', 'show_phone', 'show_message']) {
      if (section[key] !== undefined && typeof section[key] !== 'boolean') errors.push('Formulärfälten behöver giltiga av/på-inställningar.');
    }
    return [...new Set(errors)];
  }
  if (section.type === 'hero') {
    if (section.variant === 'studio-hero-statement') {
      const proof = section.proof_cards || [];
      if (!Array.isArray(proof) || proof.length > 3) errors.push('Hero tillåter högst tre förtroendekort.');
      else for (const item of proof) {
        if (!item || typeof item.value !== 'string' || !item.value.trim() || item.value.length > 140 ||
            typeof item.label !== 'string' || !item.label.trim() || item.label.length > 400)
          errors.push('Förtroendekorten kräver värde och beskrivning.');
        if (!isVerified(item)) errors.push('Förtroendekorten behöver verifierad källa och datum.');
      }
      const rating = section.rating_claim || {};
      if (rating && Object.values(rating).some(Boolean)) {
        const score = String(rating.score || '').replace(',', '.');
        if (!/^[0-5](?:\.[0-9])?$/.test(score) || Number(score) > 5)
          errors.push('Betyget behöver vara mellan 0 och 5.');
        if (!isVerified({verified:rating.verified,verified_at:rating.verified_at,source_url:rating.source_url}))
          errors.push('Betyget behöver verifierad HTTPS-källa och datum.');
      }
    }
    if (!section.headline?.trim()) errors.push('Hero behöver en rubrik.');
    if ((section.hero_image || section.image) && !safeUrl(section.hero_image || section.image, true)) errors.push('Bilden behöver en giltig HTTPS-adress eller en lokal sökväg.');
    if ((section.hero_image || section.image) && !(section.image_alt || section.hero_image_alt)?.trim()) errors.push('Beskriv hero-bilden med en alt-text.');
    for (const cta of [section.cta_primary, section.cta_secondary]) if (cta?.text && !safeUrl(cta.link)) errors.push('Knappen behöver en giltig länk.');
  } else {
    for (const item of section.items || []) {
      if (!isVerified(item)) errors.push('Varje publicerad uppgift behöver en HTTPS-källa, ett verifieringsdatum och bekräftad kontroll.');
      if (section.type === 'testimonials' && (!item.quote?.trim() || !item.author?.trim())) errors.push('Omdömen behöver citat och avsändare.');
      if (section.type === 'trust_bar' && !item.label?.trim()) errors.push('Förtroendepunkter behöver en beskrivning.');
      if (item.rating !== undefined && item.rating !== '' && ![1, 2, 3, 4, 5].includes(Number(item.rating))) errors.push('Recensionsbetyg måste vara ett heltal mellan 1 och 5.');
    }
  }
  return [...new Set(errors)];
}
module.exports = { VARIANTS, TEMPLATES, createSection, isPremiumSection, safeUrl, isVerified, publishableItems, validationErrors };